module.exports = __webpack_public_path__ + "static/media/Sketches-4.12c24568.jpg";